// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2c5e7a91","520":"1dd7e470","732":"57104c9b","847":"92327982"}[chunkId] + ".chunk.js";
};